export const btnSizes = [
    'lg',
    'md',
    'sm',
    'xs',
    'large',
    'medium',
    'small',
    'extra-small'
];

export const btnStyles = [
    'default',
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
    'link'
];
